import {
  PrimaryLightTextColor,
  PrimaryTextColor,
  boldFont,
  getRelativeFontSize,
  primaryRedColor,
  regularFont,
} from "../../../../../utils/styles";

const OfficialInformationStyles = {
  officalInfoWrapper: {},
  header: {
    paddingBottom: "30px ",
    marginTop: 5,
  },

  pageInfoHeader: {
    position: "absolute",
    left: "115px",
    top: "10px",
  },

  Heading: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
  },

  text: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },

  pageHeading: {
    fontSize: getRelativeFontSize(2),
    ...boldFont,
    color: PrimaryTextColor,
  },
  pageText: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },
  avtarStyle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    border: "4px solid #ECEDFC",
    //  overflow: "hidden",
    padding: "5px",
    position: " relative",
    "& img": {
      width: "100%",
      height: " auto",
      overflow: "hide",
    },
  },

  dateField: {
    minHeight: '38px', 
    // height: '38px',
    width: '100%',
    
    '& .MuiInputBase-root': {
      height: '38px',
      overflow: "hidden"
    },
    '& .MuiSvgIcon-root':{
      height:"18px"
    },
    '& .MuiInputBase-input':{
      fontSize:"14px",
    },
    "& .MuiFormHelperText-root": {
      color: "#E92B2B",
      fontSize: getRelativeFontSize(-1),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
  },
  uploadIcon: {
    position: " absolute",
    bottom: "-15px",
    right: "-10px",
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    background: "#ECEDFC",
  },
  custombuttonStyle: {
    width: "200px",
  },

  workingLabel: {
    ...regularFont,
    fontSize: getRelativeFontSize(0),
  },
  checkBoxPart:{
    display: "flex",
    "& .MuiFormControlLabel-label":{
      fontSize: getRelativeFontSize(0),
    ...regularFont,
    },
  },
  CheckLabel: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    ...regularFont,
  },

  label: {
    ...regularFont,
    fontSize: getRelativeFontSize(0),
    wordSpacing: "2px",
    color: PrimaryTextColor,
  },
  autocompleteStyle: {
    minHeight: '38px', 
    // maxHeight: "40px", // Fixed height for the input field
    overflow: "hidden", // Prevent vertical overflow
    "& .MuiAutocomplete-tag": {
      // height: "auto",
      height: '38px',
    },
    "& .MuiChip-root": {
      maxWidth: "none", // Allow chips to take their natural size
      overflow: "hidden", // Prevent text overflow
      textOverflow: "ellipsis", // Truncate text with ellipsis
      whiteSpace: "nowrap", // Prevent text wrapping
    },
    "& .MuiChip-label": {
      fontSize: "11px", // Adjust font size for better fit
      padding: "0 8px",
      textOverflow: "ellipsis", // Truncate text with ellipsis
      whiteSpace: "nowrap", // Prevent text wrapping
      overflow: "hidden", // Hide overflowing text
    },
    "& .MuiAutocomplete-popupIndicator": {
      marginLeft: "auto",
    },
    "& .MuiTextField-root": {
      maxHeight: "38px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display: "flex",
      flexWrap: "nowrap", // Keep everything in a single line
      overflow: "hidden", // Hide overflowing chips
      height: "40px", // Fixed height for consistent layout
      fontSize: "14px",
      alignItems: "center", // Align items vertically
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .MuiAutocomplete-input": {
      minWidth: "0px",
      height: '38px',
    },
    "& .MuiSvgIcon-root": {
      display: "none",
    },
    "& .MuiAutocomplete-inputRoot": {
      height: '38px',
      paddingRight: "0px",
      alignItems: "center", // Center align chips and input
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
  },
  autocomplateStyle: {
    width: "100%",
    background: "#fffff",
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(-1),
        color: PrimaryLightTextColor,
      },
    },
    "& .MuiAutocomplete-input":{
      padding: "4px 5px !important",
      fontSize: getRelativeFontSize(0),
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      padding: "4px 9px",
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
  },

  buttonWrapper: {
    display: "flex",
    gap: "50px",
  },
  textField:{
    "& .MuiFormHelperText-root": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(-1),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& input[type='file']": {
      diaplay: "flex",
      alignItems: "center",
      padding: "5px 10px",
      height: "28px",
      fontSize: getRelativeFontSize(0),
      ...regularFont,
    },
  }
};

export default OfficialInformationStyles;
